import React, {useContext} from 'react';
import HeaderStyleOutput from "./HeaderStyleOutput";
import HeaderSizeOutput from "./HeaderSizeOutput";
import HeaderTitleOutput from "./HeaderTitleOutput";
import HeaderShortTitleOutput from "./HeaderShortTitleOutput";
import HeaderTitleURLOutput from "./HeaderTitleURLOutput";
import HeaderTitleOnClickOutput from "./HeaderTitleOnClickOutput";
import ModifierClassesOutput from "./ModifierClassesOutput";
import SearchOutput from "./SearchOutput";
import IconOutput from "./IconOutput";
import HeaderLogoOutput from "./HeaderLogoOutput";
import ConfiguratorUtahIdOutput from "../UtahId/ConfiguratorUtahIdOutput";
import OutputLines from "./OutputLines";
import MobXContext from "../../../app/mobx/MobXContext";

const propTypes = {};
const defaultProps = {};

const ConfiguratorOutputHeader = () => {
	const {appStore} = useContext(MobXContext);
	const baseIndent = 0;
	return (
		<>
			<OutputLines
				baseIndent={baseIndent}
				lines = {[
					{indent: baseIndent, output: `<script src="https://cdn.utah.gov/utah-header/${appStore.currentVersion}/utahHeader.bundle.js"></script>`},
					{indent: baseIndent, output: ' '},
					{indent: baseIndent, output: '<script>'},
					{indent: baseIndent + 1, output: 'function loadConfig() {'},
					{indent: baseIndent + 2, output: 'window.utahHeader.setConfig({'},
				]}
			 />

			<HeaderLogoOutput baseIndent={baseIndent + 3}/>
			<HeaderStyleOutput baseIndent={baseIndent + 3}/>
			<HeaderSizeOutput baseIndent={baseIndent + 3}/>
			<HeaderTitleOutput baseIndent={baseIndent + 3}/>
			<HeaderShortTitleOutput baseIndent={baseIndent + 3}/>
			<HeaderTitleURLOutput baseIndent={baseIndent + 3}/>
			<HeaderTitleOnClickOutput baseIndent={baseIndent + 3}/>
			<ModifierClassesOutput baseIndent={baseIndent + 3}/>
			<IconOutput iconName="appGrid" baseIndent={baseIndent + 3}/>
			<SearchOutput baseIndent={baseIndent + 3}/>
			<IconOutput iconName="gear" baseIndent={baseIndent + 3}/>
			<IconOutput iconName="question" baseIndent={baseIndent + 3}/>
			<ConfiguratorUtahIdOutput baseIndent={baseIndent + 3}/>

			<OutputLines
				baseIndent={baseIndent}
				lines = {[
					{indent: baseIndent + 2, output: '});'},
					{indent: baseIndent + 1, output: '}'},
					{indent: baseIndent, output: ' '},
					{indent: baseIndent + 1, output: 'if (window.utahHeader && window.utahHeader.isLoaded) {'},
					{indent: baseIndent + 2, output: 'loadConfig();'},
					{indent: baseIndent + 1, output: '} else {'},
					{indent: baseIndent + 2, output: 'window.addEventListener(\'ugovHeaderLoaded\', function () {'},
					{indent: baseIndent + 3, output: 'loadConfig();'},
					{indent: baseIndent + 2, output: '});'},
					{indent: baseIndent + 1, output: '}'},
					{indent: baseIndent, output: '</script>'},
				]}
			/>
		</>
	);
};

ConfiguratorOutputHeader.propTypes = propTypes;
ConfiguratorOutputHeader.defaultProps = defaultProps;

export default ConfiguratorOutputHeader;
